'use strict'

import React from 'react'
import { Link } from 'react-router'
import $ from 'jquery'
import qs from 'qs'

require('styles/Pager.less')

class Pager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prev:0,
      next:2
    }
  }
  componentDidMount() {
    var { totalpage, num } = this.props
    this.setState({
      prev:num-1,
      next:num+1
    })
  }
  render() {
    var prefix = "?page="
    var query = ""
    if (location.search) {
      var query = location.search.split("?")[1]
    }
    var { current, totalpage } = this.props
    var isPager = false
    if (totalpage > 1) isPager = true
    var numberList = []
    var begin = current == 1 ? 1 : current-1
    if (begin > totalpage - 2) begin -= 1
    if (begin < 1) begin = 1
    for (var i = begin; i <= totalpage; i++)
    {
      if (i == begin+3 || i > totalpage) break;
      var cl = ''
      if (i == current) cl='current'
      if (this.props.type == 'top')
      {
        numberList.push(<li key={i}><Link to={'/page/' + i} className={cl}><span>{i}</span></Link></li>)
      }
      else
      {
        var obj = qs.parse(query);
        obj["page"] = i
        numberList.push(<li key={i} data-page={i}><Link to={'/?'+qs.stringify(obj)} data-page={i} className={cl}><span>{i}</span></Link></li>)
      }
    }
    var prevLt = ''
    if (current <= 1) prevLt = 'disappear'
    var first = ''
    if (current < 3 || totalpage == 3) first = 'disappear'
    var nextGt = ''
    if (current == totalpage) nextGt = 'disappear'
    var last = ''
    if (totalpage <= 3 || current > totalpage -2) last = 'disappear'

    var prevQ = qs.parse(query);
    prevQ["page"] = this.state.prev;
    var nextQ = qs.parse(query);
    nextQ["page"] = this.state.next;
    var lastQ = qs.parse(query);
    lastQ["page"] = totalpage
    var firstQ = qs.parse(query);
    firstQ["page"] = 1

    return (
      <div className='pager_container'>
      { isPager ?
        <div className='pager'>
          <div className={'prev p ' + prevLt}>
            { this.props.type == 'top' ?
              <Link to={'/page/' + this.state.prev}><span>&lt;</span></Link>
            :
              <Link to={'/?'+qs.stringify(prevQ)} data-page={this.state.prev}><span>&lt;</span></Link>
            }
          </div>
          <div className='inner'>
            <div className={'first p ' + first}>
              { this.props.type == 'top' ?
                <div className='j'>
                  <Link to='/'>First</Link><span className='bar'>—</span>
                </div>
              :
                <div className='j'>
                  <Link to={'/?'+qs.stringify(firstQ)} data-page='1'>First</Link><span className='bar'>—</span>
                </div>
              }
            </div>
            <ul className='number p'>{numberList}</ul>
            <div className={'last p ' + last}>
              { this.props.type == 'top' ?
                <div className='j'>
                  <span className='bar'>—</span><Link to={'/page/' + totalpage}><span>Last</span></Link>
                </div>
              :
                <div className='j'>
                  <span className='bar'>—</span><Link to={'/?'+qs.stringify(lastQ)} data-page={totalpage}><span>Last</span></Link>
                </div>
              }
            </div>
          </div>
          <div className={'next p ' + nextGt}>
            { this.props.type == 'top' ?
              <Link to={'/page/' + this.state.next}><span>&gt;</span></Link>
            :
              <Link to={'/?'+qs.stringify(nextQ)} data-page={this.state.next}><span>&gt;</span></Link>
            }
          </div>
        </div>
      :null}
      </div>
    )
  }
}

Pager.displayName = 'Pager'

Pager.propTypes = {}
Pager.defaultProps = {}

export default Pager



// WEBPACK FOOTER //
// ./src/components/PagerComponent.js